import apiClient from '../api-client';
import type { Store, CreateStoreRequest, UpdateStoreRequest, PaginatedResponse, PaginationParams } from '@geely/shared';

export const storesApi = {
  list: () =>
    apiClient.get<Store[]>('/stores'),

  listPaginated: (params: PaginationParams) =>
    apiClient.get<PaginatedResponse<Store>>('/stores', { params }),

  getById: (id: string) =>
    apiClient.get<Store>(`/stores/${id}`),

  create: (data: CreateStoreRequest) =>
    apiClient.post<Store>('/stores', data),

  update: (id: string, data: UpdateStoreRequest) =>
    apiClient.patch<Store>(`/stores/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/stores/${id}`),
};
